/**
 * CetusEd Admin Console — Admin Auth Hook
 *
 * COMPLIANCE: Centralizes access to the admin auth context. Every admin
 *   component MUST use this hook to ensure null-checking per ⛔ Rule 2
 *   (fail closed). If the context is not available, throw.
 */

import { useContext } from 'react';
import { AppError } from '@cetused/shared';
import { AdminAuthContext, type AdminUser } from './AdminAuthProvider';

export interface UseAdminAuthResult {
  token: string | null;
  user: AdminUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string, mfaCode: string) => Promise<void>;
  logout: () => void;
}

export function useAdminAuth(): UseAdminAuthResult {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw AppError.internal(
      'useAdminAuth must be used within an AdminAuthProvider. Wrap your component tree with <AdminAuthProvider>.',
    );
  }
  return context;
}
